import {
  Box,
  BoxProps,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { useAuth } from '../../../../../../../../../hooks/auth';
import { UserCategoryTable } from './components/UserCategoryTable';
import { VentureExperienceLevelTable } from './components/VentureExperienceLevelTable';
import { VentureSpotTable } from './components/VentureSpotTable';

export const VentureDetailsTabs = (props: BoxProps): JSX.Element => {
  const [tabIndex, setTabIndex] = useState(0);

  const { assignment: authenticatedAssignment } = useAuth();

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <Box {...props}>
      <Tabs
        index={tabIndex}
        onChange={handleTabChanges}
        variant="enclosed-colored"
        isLazy
      >
        <TabList>
          <Tab>Locais</Tab>

          <Tab>Categorias de usuário</Tab>

          {authenticatedAssignment?.featureGroup.features.some((feature) =>
            [
              'VENTURE_EXPERIENCE_LEVEL_FULL_ACCESS',
              'VENTURE_EXPERIENCE_LEVEL_READ_ACCESS',
            ].includes(feature.key),
          ) && <Tab>Níveis de experiência</Tab>}
        </TabList>

        <TabPanels mt="4">
          <TabPanel>
            <VentureSpotTable />
          </TabPanel>

          <TabPanel>
            <UserCategoryTable />
          </TabPanel>

          {authenticatedAssignment?.featureGroup.features.some((feature) =>
            [
              'VENTURE_EXPERIENCE_LEVEL_FULL_ACCESS',
              'VENTURE_EXPERIENCE_LEVEL_READ_ACCESS',
            ].includes(feature.key),
          ) && (
            <TabPanel>
              <VentureExperienceLevelTable />
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
